import { DashboardCardNameEnum } from "@ryde/shared";

/**
 * `cardNames` is required by the endpoint but this page reads only the id-keyed
 * results, so it stays empty: every card travels in `cards` instead. Sending both
 * would make the backend compute each card twice — once per name, once per
 * instance — for a payload nobody reads. `cardNames` is still how the original
 * dashboard page asks for its cards.
 */
export const LEGACY_CARD_NAMES: DashboardCardNameEnum[] = [];
